const constants = {
  postsPerFeedPage: 5, // Posts per feed page
  feedMetaDirectory: "feed_meta/", // Directory for storing the feed page metadata
};

export default constants;
